import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { findInsuranceByType, getInsuranceInitialValues } from './utils';

import type { RootState } from '../../../../../../../store';
import type { InsuranceType } from '../../../../../../../utils/types';

export default function useInsuranceInitialValues(insuranceType: InsuranceType) {
  const insurance = useSelector((state: RootState) => {
    const insurances = state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.insurances;
    return findInsuranceByType(insurances, insuranceType);
  });

  return useMemo(() => getInsuranceInitialValues(insurance), [insurance]);
}
